import React from 'react';
import { motion } from 'framer-motion';

const moments = [
  'The first team meeting, when everyone waits for you to set the tone.',
  'The first 1:1 with someone who was your peer last month.',
  'The first time someone underperforms and you have to name it plainly.',
  'The first time you have to say no to your own boss.'
];

function ProblemSection() {
  return (
    <section className="problem section">
      <div className="shell narrow">
        <p className="eyebrow">The job starts before the training does</p>
        <h2>The difficult moments do not wait until you feel ready.</h2>
        <p className="section-intro">
          You do not need another leadership model. You need to know what to
          say on Tuesday morning.
        </p>
        <div className="moment-list">
          {moments.map((moment, index) => (
            <motion.div
              className="moment"
              key={moment}
              initial={{ opacity: 0, x: -16 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: '-60px' }}
              transition={{ delay: index * 0.08 }}
            >
              <span>{String(index + 1).padStart(2, '0')}</span>
              <p>{moment}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default ProblemSection;